import { 
  gql, 
  useQuery 
} from "@apollo/client";
import { 
  MerchantsOverviewOnboardingAdminQueryQuery,
    QueryMerchantsOverviewOnboardingAdminArgs 
} from "../../../../../../schemaTypes";

export const merchantsOverviewOnboardingAdminQuery = gql`
  query MerchantsOverviewOnboardingAdminQuery(
    $duration: String!
  ) {
    merchantsOverviewOnboardingAdmin(
      duration: $duration 
    ) {
        accountsCreated
        accountsVerified
        onboarded1
        onboarded2
    }
  }
`;

export interface WithMerchantsOverviewOnboardingAdmin {
  accountsCreated: number;
  accountsVerified: number;
  onboarded1: number;
  onboarded2: number;
}

interface Props {
  variables: QueryMerchantsOverviewOnboardingAdminArgs;
  children: (data: WithMerchantsOverviewOnboardingAdmin) => React.ReactElement | null;
}

export const MerchantsOverviewOnboardingAdminController: React.FC<Props> = ({ children, variables }) => {
  const { data } = useQuery<
    MerchantsOverviewOnboardingAdminQueryQuery,
    QueryMerchantsOverviewOnboardingAdminArgs
  >(merchantsOverviewOnboardingAdminQuery, {
    variables,
    notifyOnNetworkStatusChange: true,
  });

  const accountsCreated = data?.merchantsOverviewOnboardingAdmin?.accountsCreated || 0;
  const accountsVerified = data?.merchantsOverviewOnboardingAdmin?.accountsVerified || 0;
  const onboarded1 = data?.merchantsOverviewOnboardingAdmin?.onboarded1 || 0;
  const onboarded2 = data?.merchantsOverviewOnboardingAdmin?.onboarded2 || 0;

  return children({
        accountsCreated,
        accountsVerified,
        onboarded1,
        onboarded2
  });
};